import { Purchase, PurchaseUnit } from "../data/purchase";
import Food from "../data/food";

export function formatPurchaseDescription(purchase: Purchase | undefined) {
  return purchase
    ? purchase.brand
      ? `${purchase.brand} ${purchase.description}`
      : `${purchase.description}`
    : "";
}

export function updatePurchaseWithFood<T>(
  purchase: Purchase,
  food: Food,
): Purchase {
  return {
    ...purchase,
    description: food.description,
    kcal: food.kcal || purchase.kcal,
    carbs: food.carbs,
    protein: food.protein,
    fat: food.fat,
  };
}

export function getDefaultPurchaseUnit(purchase: Purchase) {
  const defaultPurchaseUnit = purchase.purchaseUnits.find((pu) => pu.isDefault);
  if (defaultPurchaseUnit == undefined) {
    throw new Error("Keine Default Purchase-Unit gefunden");
  }
  return defaultPurchaseUnit;
}

export function formatPurchaseUnitWithAmountDescription(
  purchase: Purchase,
  purchaseUnit: PurchaseUnit,
  amount: number,
) {
  return `${formatPurchaseDescription(purchase)} ${amount.toLocaleString()} x ${purchaseUnit.description}`;
}

/**
 * Wählt aus den PurchaseUnits eines Produkts die passende Einheit:
 * zuerst über die FoodUnit-ID, dann über Nettogewicht/Beschreibung,
 * dann die 1g-Einheit, sonst die erste.
 */
export function selectPurchaseUnit(
  purchase: Purchase,
  target: {
    foodUnitId?: number;
    oldNetWeight?: number;
    oldUnitDescription?: string;
  },
): PurchaseUnit | undefined {
  const matching =
    purchase.purchaseUnits.find(
      (pu) => pu.foodUnitId === target.foodUnitId && pu.foodUnitId != null,
    ) ??
    purchase.purchaseUnits.find(
      (pu) =>
        pu.netWeight === target.oldNetWeight ||
        pu.description === target.oldUnitDescription,
    );
  return (
    matching ??
    purchase.purchaseUnits.find((pu) => pu.netWeight === 1) ??
    purchase.purchaseUnits[0]
  );
}

/** Rechnet eine Menge über das Verhältnis der Nettogewichte um (1 Dezimalstelle). */
export function convertByNetWeight(
  amount: number,
  oldNetWeight: number | undefined,
  newNetWeight: number | undefined,
): number {
  const oldWeight = oldNetWeight ?? 1;
  const newWeight = newNetWeight ?? 1;
  if (oldWeight === newWeight) return amount;
  return Math.round(amount * (oldWeight / newWeight) * 10) / 10;
}
